import { PlayerInterface, PotInterface } from '../constants/common.interface';

export function calculateThePot(players: PlayerInterface[]) {
    const resultPots: PotInterface[] = [];
    let nextPlayers: PlayerInterface[] = [...players];
    let currentPlayers: PlayerInterface[] = [];
    let currentPot: PotInterface = {
        name: 'Side Pot',
        sum: 0,
        players: [],
    };
    let resultHasMainPot: boolean = false;

    while (nextPlayers.length > 0) {
        currentPlayers.length = 0;
        currentPlayers = nextPlayers;
        const playerBets: number[] = currentPlayers.map((player: PlayerInterface) => player.betSum);
        const minimalBet: number = Math.min(...playerBets);
        currentPot = {
            name: `Side Pot ${resultPots.length + (resultHasMainPot ? 0 : 1)}`,
            sum: 0,
            players: [],
        };
        nextPlayers = [];

        // Calculate
        for (let i = 0; i < currentPlayers.length; i++) {
            const name: string = currentPlayers[i].name;
            const index: number = currentPlayers[i].index;
            const standingBet: number = currentPlayers[i].betSum - minimalBet;

            currentPot.sum += minimalBet;
            currentPot.players.push(index);

            if (standingBet > 0) {
                nextPlayers.push({
                    name: name,
                    betSum: standingBet,
                    index: index,
                });
            }
        }
        if (currentPot.players.length === players.length) {
            currentPot.name = 'Main Pot';
            resultHasMainPot = true;
        }
        resultPots.push(currentPot);
    }
    return resultPots;
}